import { api } from '@creditsights/api-ui-web';

export interface SendFeedbackRequest {
  sessionId: string;
  seqId: number;
  comments: string;
  user_feedback_type: string;
  feedback_body: {
    user_thumbs_up: boolean;
    user_thumbsup_feedback?: { doclink: string; user_thumbs_up: boolean }[];
    user_thumbsdown_feedback?: { correct_response: string; correct_sources: string };
  };
}

export const sendFeedback = async ({ sessionId, seqId, ...params }: SendFeedbackRequest): Promise<void> => {
  const { data } = await api.post(`/cs-genie/v1/feedback?sessionId=${sessionId}&seq_id=${seqId}`, params);
  return data;
};
